import { Input } from '@carrotfertility/carotene';
import { WidgetProps } from '@rjsf/core';
import React from 'react';
import { getHumanReadableErrorMessage } from './errorHandling';
import { CarrotJsonSchema, JsonSchemaFormInputProps } from './types';

interface BaseInputProps extends WidgetProps, JsonSchemaFormInputProps {
    usePlaceHolders: boolean;
}

export function BaseInput(props: BaseInputProps) {
    const {
        label,
        value,
        rawErrors,
        disabled,
        options,
        required,
        onChange,
        schema,
        usePlaceHolders,
        overrideTitle,
        overrideErrorMessage,
    } = props;

    const carrotSchema = schema as CarrotJsonSchema;

    function handleOnChange(event: React.ChangeEvent<HTMLInputElement>) {
        const { value } = event.target;

        return onChange(value === '' ? options.emptyValue : value);
    }

    const helperMessage = carrotSchema?.helperMessage;
    const isError = rawErrors?.length > 0;
    let errorMessage;

    if (isError) {
        errorMessage = overrideErrorMessage
            ? overrideErrorMessage(carrotSchema.validationMessage, carrotSchema)
            : getHumanReadableErrorMessage(schema);
    }

    if (carrotSchema?.placeholder === true && usePlaceHolders) {
        return (
            <Input
                {...{
                    label: overrideTitle ? overrideTitle(label) : label,
                    placeholder: value,
                    onChange: handleOnChange,
                    disabled,
                    isRequired: required,
                    isError,
                    errorMessage,
                    helperMessage,
                }}
            />
        );
    } else {
        return (
            <Input
                {...{
                    label: overrideTitle ? overrideTitle(label) : label,
                    value,
                    onChange: handleOnChange,
                    disabled,
                    isRequired: required,
                    isError,
                    errorMessage,
                    helperMessage,
                }}
            />
        );
    }
}
